import styled from 'styled-components';
import { Loader } from '~/shared/components';

export const Root = styled.div`
  height: 400px;
  width: 100%;
  position: relative;
  margin-top: 10px;
`;

export const HighchartContainer = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  border: 1px solid #e6e9eb;
  background-color: var(--background-chart);
  border-radius: 4px;
  padding: 10px;
  .highcharts-button-symbol {
    width: 3.5px !important;
  }
  .highcharts-button-box {
    x: 2;
    y: 1;
    rx: 16;
    ry: 16;
    &:hover {
      fill: #d4e5ff !important;
    }
  }
  .highcharts-button-symbol {
    width: 3.5px !important;
    fill: #4c5e72 !important;
    stroke: transparent !important;
    pointer-events: none;
  }
  .highcharts-yaxis-labels {
    text {
      text-align: left;
      width: 72px !important;
      x: 0 !important;
    }
  }
  .highcharts-legend-item {
    text {
      text-decoration: none !important;
    }
  }
  .highcharts-legend-item-hidden {
    text {
      text-decoration: none !important;
      opacity: 0.5 !important;
    }
    path {
      text-decoration: none !important;
      opacity: 0.5 !important;
    }
  }
`;

export const AlignedLoader = styled(Loader)`
  left: calc(50% - 25px);
  top: calc(50% - 30px);
`;

export const ControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 20px;
  right: 65px;
  gap: 6px;
  align-items: flex-end;
  z-index: 2;

  .select-title {
    padding-right: 3px !important;
    padding-top: 2px !important;
  }

  .sma-row .MuiOutlinedInput-root {
    height: 34px !important;
    min-height: 34px !important;
    padding: 0 8px !important;
    margin-top: 8px !important;
    display: flex !important;
    align-items: center !important;
    background: var(--background-chart);
  }

  .sma-row .MuiOutlinedInput-notchedOutline {
    border-radius: 5px;
    border: 1px solid #99a3af;
  }

  .sma-row .MuiOutlinedInput-input {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    font-size: 15px !important;
    font-weight: 400 !important;
    color: #33485e !important;
  }

  .sma-row .MuiSelect-icon {
    top: 3px;
    color: #33485e;
  }

  .sma-row fieldset {
    top: -4px !important;
    height: 37px !important;
  }
`;

export const ControlsRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const SelectTitle = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  height: 24px;
`;
